import { useMemo } from "react";
import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { Link as LinkTo } from "react-router";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { useObrasMateriaisControladosViewModel } from "../../viewModels/obras_materiais_controlados_view_model";
import { GetAllObrasMateriaisControladosModel } from "../../../domain/models/obras_materiaisc_ontrolados";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateControleColumnDefinition } from "./columns";
import { ObrasMateriaisControladosModal } from "./components/obras_materiais_controlados_modal";

import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";

export const ObrasMateriaisControlados = () => {
  const viewModel = useObrasMateriaisControladosViewModel();
  const columnsDefinition = useMemo(() => GenerateControleColumnDefinition({
    onActionDeletar: viewModel.handleDeleteOpenStateModal,
  }), [viewModel.handleDeleteOpenStateModal]);

  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo ?? null}
        onBack={viewModel.handleBack}
        leftBackSlotButton={
          viewModel.selectedObraHeaderInfo && !viewModel.errorMessage ? (
            <div className="w-[130px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                onClick={() => viewModel.handleOpenIncluirModal(true)}>
                Novo item
              </PrimaryButton>
            </div>
          ) : null
        }
      />

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">Obras</Link>
          <Link underline="hover" color="inherit" component="span">
            <LinkTo to="/Obras_lista">Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">Relação de Materiais Controlados</Typography>
        </Breadcrumbs>

        <div className="flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title="Relação de Materiais Controlados"
            selectedObra={viewModel.selectedObraHeaderInfo ?? null}
            onReload={viewModel.handleReload}
          />
        </div>

        {viewModel.errorMessage !== undefined ? (
          <div className="w-full">
            <AlertError messageErro={viewModel.errorMessage} onTryAgain={viewModel.handleReload} />
          </div>
        ) : (
          <Stack spacing={0}>
            <div className="w-full flex flex-row justify-between items-stretch">
              <div className="flex flex-col flex-wrap">
                <LegendComponent />
              </div>
            </div>

            <StyledDataGrid
              tableName="obras_materiaiscontrolados"
              disableColumnMenu={false}
              disableRowSelectionOnClick={true}
              getRowId={(row: GetAllObrasMateriaisControladosModel) => row.idObraMateriaisControlados}
              columns={columnsDefinition}
              loading={viewModel.loading}
              rows={viewModel.materiaisControlados}
              rowCount={viewModel.pagination.totalItems}
              pageSizeOptions={[10, 25, 50, 100]}
              paginationMode="server"
              paginationModel={{
                page: viewModel.pagination.page - 1,
                pageSize: viewModel.pagination.rowsPerPage,
              }}
              pinnedColumns={{ right: ["idObraMateriaisControlados"] }}
            />

            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, page) => viewModel.handlePageChange(page)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value, 10))}
            />
          </Stack>
        )}
      </div>

      <ObrasMateriaisControladosModal
        open={viewModel.openIncluirModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        materiaisControlados={viewModel.materiaisControladosDropdown}
        onClose={() => viewModel.handleOpenIncluirModal(false)}
        onSubmit={viewModel.handleIncluirSubmit}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        saving={viewModel.saving}
        onClose={() => viewModel.handleDeleteOpenStateModal(null, false)}
        title="Você realmente deseja excluir este item?"
        onDelete={viewModel.handleDeleteConfirm}
      />

      <ObrasReportModals state={viewModel.obrasReportState} />
    </>
  );
};
